import { createContext, useContext } from 'react';

/**
 * Where a mindspace filter is drawn.
 *
 * - `'panel'` - the desktop side panel: collapsible sections, compact
 *   controls, each long list in its own capped scroller.
 * - `'sheet'` - the phone bottom sheet: every section open on one scroll (no
 *   tapping a section open to see what is in it, no scroller inside the
 *   sheet's scroller), 44px controls, a mono label per section.
 *
 * A context rather than a prop on each filter, because the filters are
 * composed by two panels (Knowledge Archive, Quick Bytes) and the choice is
 * the panel's, made once.
 */
export type FilterLayout = 'panel' | 'sheet';

export const FilterLayoutContext = createContext<FilterLayout>('panel');

export const useFilterLayout = () => useContext(FilterLayoutContext);
